import { useTranslation } from "react-i18next";
import DefaultCheckbox from "./DefaultCheckbox"
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useContext, useEffect, useState } from "react";
import { debounceFunction } from "../../../../utils/utilFunctions";
import { eachDeep } from "deepdash-es/standalone";
import { cloneDeep, debounce, isEqual } from "lodash";
import { Checkbox, FormControl, FormControlLabel, TextField } from "@mui/material";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { treeActions } from "../../../../redux/slices/treeSlice";
import { LoadingEase } from "../../../LoadingEase";

export const WorkflowSession = ({updatedSelectedNode, setUpdatedSelectedNode}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  //redux 
  const parentScreen = useContext(ParentScreenCtx);
  const queryParams = useSelector((state) => state.queryParams);
  const { rightTree } = useSelector((state) => state.treeData[parentScreen]);
  const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
  const selectedNode = rightTree.tree[rightTree.currentTab].selectedNode;
  const templateHeader = rightTree.tree.templateHeader;
  const account = queryParams.account;

  const [enabled, setEnabled] = useState(false);
  const [wfSessionVal, setWfSessionVal] = useState('');
  const [applyFieldPropsVal, setApplyFieldPropsVal] = useState(false); //FORMAT_WFSESSION_VAR
  const [loaded, setLoaded] = useState(false);

  //selectNode change
  useEffect(() => {
    setInitialInputVals();
  }, [selectedNode?.key]);

  const setInitialInputVals = () => {
    
    //failsafe incase issue with selected node
    if (selectedNode) {
      let sn = selectedNode;

      // - Add to Workflow Session - checkbox
      if (sn.WF_SESSION_NAME || sn.FIELD?.WF_SESSION_NAME) setEnabled(true);
      else setEnabled(false);
      
      // - WF_SESSION_NAME -  text input
      if (sn.WF_SESSION_NAME) setWfSessionVal(sn.WF_SESSION_NAME);
      else if (sn.FIELD?.WF_SESSION_NAME) setWfSessionVal(sn.FIELD.WF_SESSION_NAME);
      else setWfSessionVal("");

      // - Apply Field Properties - FORMAT_WFSESSION_VAR - uneditable text field
      if (sn.FORMAT_WFSESSION_VAR || sn.FIELD?.FORMAT_WFSESSION_VAR) setApplyFieldPropsVal(true);
      else setApplyFieldPropsVal(false);
    }
    setLoaded(true);
  }

  const modifyUpdatedNode = (prop, val) => {
    if (prop === "enabled") {
      if (val === '' || val === false || val === null) {
        //if enabled checkbox is false, delete the other two props.
        if (updatedSelectedNode?.FIELD) {
          //write to node's FIELD prop
          setUpdatedSelectedNode(prev => {
            return {...prev, FIELD: {...prev.FIELD, ...{
              'WF_SESSION_NAME': null,
              'FORMAT_WFSESSION_VAR': null,
              'WF_SESSION_NAME': null,
              'FORMAT_WFSESSION_VAR': null
            }}}
          });
        } else {
          //write to node directly
          setUpdatedSelectedNode(prev => {
            return {...prev, ...{
              'WF_SESSION_NAME': null,
              'FORMAT_WFSESSION_VAR': null,
              'WF_SESSION_NAME': null,
              'FORMAT_WFSESSION_VAR': null
            }}
          });
        }
      } else {
        //checkbox is true
        if (updatedSelectedNode?.FIELD) {
          // if (updatedSelectedNode?.FIELD?.MAPNAME) {
          //   //case: use MAPNAME first if node has it
          //   setUpdatedSelectedNode(prev => {
          //     return {...prev, FIELD: {...prev.FIELD, ['WF_SESSION_NAME']: updatedSelectedNode?.FIELD?.MAPNAME}}
          //   });
          // } else if (updatedSelectedNode?.FIELD?.DESCRIPTION) {
          //   //case: use Desc if node has it
          //   setUpdatedSelectedNode(prev => {
          //     return {...prev, FIELD: {...prev.FIELD, ['WF_SESSION_NAME']: updatedSelectedNode?.FIELD?.DESCRIPTION}}
          //   });
          // } else {
            //case: else use UNNAMED + Date.now()  like swt does.
            // setUpdatedSelectedNode(prev => {
            //   return {...prev, FIELD: {...prev.FIELD, ['WF_SESSION_NAME']: `UNNAMED${Date.now()}`}}
            // });
            setUpdatedSelectedNode(prev => {
              return {...prev, FIELD: {...prev.FIELD, 'WF_SESSION_NAME': updatedSelectedNode?.ELEMENT_NAME || updatedSelectedNode?.DESCRIPTION || `UNNAMED${Date.now()}`}}
            });
          // }
        } else {
          // if (updatedSelectedNode?.MAPNAME) {
          //   //case: use MAPNAME first if node has it
          //   setUpdatedSelectedNode(prev => {
          //     return {...prev, ['WF_SESSION_NAME']: updatedSelectedNode?.FIELD?.MAPNAME}
          //   });
          // } else if (updatedSelectedNode?.DESCRIPTION) {
          //   //case: use Desc if node has it
          //   setUpdatedSelectedNode(prev => {
          //     return {...prev, ['WF_SESSION_NAME']: updatedSelectedNode?.FIELD?.DESCRIPTION}
          //   });
          // } else {
            //case: else use UNNAMED + Date.now()  like swt does.
            // setUpdatedSelectedNode(prev => {
            //   return {...prev, ['WF_SESSION_NAME']: `UNNAMED${Date.now()}`}
            // });
            if (selectedNode?.children?.length > 0) {
              setUpdatedSelectedNode(prev => {
                return {...prev, FIELD: { 'WF_SESSION_NAME': updatedSelectedNode?.ELEMENT_NAME ? updatedSelectedNode?.ELEMENT_NAME : updatedSelectedNode?.DESCRIPTION}}
              });
            } else {
              setUpdatedSelectedNode(prev => {
                return {...prev, 'WF_SESSION_NAME': updatedSelectedNode?.ELEMENT_NAME || updatedSelectedNode?.MAPNAME || updatedSelectedNode?.DESCRIPTION || updatedSelectedNode?.ATTRIBUTE_NAME || `UNNAMED${Date.now()}`}
              });
            }
            
          // }
        }
      }
    } else {
      //not checked, 
      if (val === '' || val === false|| val === null) {
        if (updatedSelectedNode?.FIELD) {
          setUpdatedSelectedNode(prev => {
            return {...prev, FIELD: {...prev.FIELD, [prop]: null}}
          });
        } else {
          setUpdatedSelectedNode(prev => {
            return {...prev, [prop]: null}
          });
        }
      } else {
        if (prop === "FORMAT_WFSESSION_VAR") {
          if (updatedSelectedNode?.FIELD) {
            setUpdatedSelectedNode(prev => {
              return {...prev, FIELD: {...prev.FIELD, [prop]: "TRUE"}}
            });
          } else {
            setUpdatedSelectedNode(prev => {
              return {...prev, [prop]: "TRUE"}
            });
          }
        } else {
          if (updatedSelectedNode?.FIELD) {
            setUpdatedSelectedNode(prev => {
              return {...prev, FIELD: {...prev.FIELD, [prop]: val}}
            });
          } else {
            setUpdatedSelectedNode(prev => {
              return {...prev, [prop]: val}
            });
          }
        }
      }
    }
    // else {
    //   //obj of props to change
    //   if (updatedSelectedNode?.FIELD) {
    //     if (val !== "" && val !== undefined) {

    //       setUpdatedSelectedNode(prev => {
    //         return {...prev, FIELD: {...prev.FIELD, ...prop}}
    //       });
    //     } else {
    //       setUpdatedSelectedNode(prev => {
    //         return {...prev, FIELD: {...prev.FIELD, ...prop}}
    //       });
    //     }
    //   } else {
    //     if (val !== "" && val !== undefined) {
    //       setUpdatedSelectedNode(prev => {
    //         return {...prev, ...prop}
    //       });
    //     } else {
    //       setUpdatedSelectedNode(prev => {
    //         return {...prev, ...prop}
    //       });
    //     }
    //   }
    // }
  }

  const handleWfSessionChange = (newVal) => {
    //TODO: add validation for this input?
    setWfSessionVal(newVal);
    modifyUpdatedNode("WF_SESSION_NAME", newVal)
    // debouncedSave("WF_SESSION_NAME", newVal, translatedData, selectedNode);
  }

  const handleWfChecked = (checked) => {
    setEnabled(checked);
    
    if (checked) {
      // if (selectedNode?.MAPNAME) {
      //   //case: use MAPNAME first if node has it
      //   setWfSessionVal(selectedNode?.MAPNAME);
      // } else if (selectedNode?.DESCRIPTION) {
      //   //case: use Desc if node has it
      //   setWfSessionVal(selectedNode?.DESCRIPTION);
      // } else {
        //case: else use UNNAMED + Date.now()  like swt does.
        // setWfSessionVal(`UNNAMED${Date.now()}`);
        setWfSessionVal(selectedNode?.ELEMENT_NAME || selectedNode?.MAPNAME || selectedNode?.DESCRIPTION || selectedNode?.ATTRIBUTE_NAME || `UNNAMED${Date.now()}`);
      // }
    } else {
      //case: else checkbox is false, delete WF_SESSION_NAME prop
      setWfSessionVal("");
    }
    return modifyUpdatedNode("enabled", checked);
    // return debouncedSave("enabled", checked, translatedData, selectedNode);
  }

  const handleApplyFieldPropsChange = (checked) => { 
    setApplyFieldPropsVal(checked);
    return modifyUpdatedNode("FORMAT_WFSESSION_VAR", checked);
    // return debouncedSave("FORMAT_WFSESSION_VAR", checked, translatedData, selectedNode);
  }

  return (
    <>
      {!loaded && <LoadingEase>{t('LOADING')} {t('LBL_WORKFLOW_SESSION_VAL')}...</LoadingEase>}
      <div style={{display: !loaded ? "none" : "unset"}}>
        <FormControlLabel
          sx={{height: '30px'}}
          className={'width-fit-content'}
          label={t("BTN_WS_USE_IN_SESSION")}
          control={
            <Checkbox 
              name={"BTN_WS_USE_IN_SESSION"}
              size={'small'}
              checked={enabled}
              onChange={(e, checked) => handleWfChecked(checked)}
            />
          } 
        />
        {enabled && (
          <div className="flex flex-wrap">
            {/* WF_SESSION_NAME */}
            <FormControl  size="small" className="margin-right-12" sx={{flexGrow: '2', maxWidth: "200px"}}>
              <TextField
                variant="outlined"
                size="small"
                autoComplete="off"
                type="text"
                className={"width-100"}
                name={"WF_SESSION_NAME"}
                value={wfSessionVal}
                onChange={(e) => {
                  handleWfSessionChange(e.target.value, e)
                }}
              />
            </FormControl>

            {/* FORMAT_WFSESSION_VAR */}
            <FormControlLabel
              sx={{height: '30px'}}
              className={'width-fit-content'}
              label={t("BTN_APPLY_FIELD_PROPERTIES")}
              control={
                <Checkbox 
                  name={"BTN_APPLY_FIELD_PROPERTIES"}
                  size={'small'}
                  checked={applyFieldPropsVal}
                  onChange={(e, checked) => handleApplyFieldPropsChange(checked)}
                />
              } 
            />
          </div>
        )}
      </div>
    </>
  )
}